<template>
    <div class="aba-preco">
        <div class="vertical-flow">
            <!-- ABA TABELA DE PREÇO -->
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissaoCadastrar && !asstabprecoprodutoIntegracao
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-toltip-aba-preco"
                    />
                </div>

                <div
                    class="column"
                    :class="[
                        permissaoCadastrar && !asstabprecoprodutoIntegracao
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        :height="40"
                        @input="carregarDados()"
                    />
                </div>

                <div
                    class="column is-3"
                    v-if="permissaoCadastrar && !asstabprecoprodutoIntegracao"
                >
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="openModal(0)"
                    >
                        {{ $t("vincular-tabela-preco") }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="precosList"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                    scrollable
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :width="f.width"
                        class="excluir-field"
                        :sortable="f.sortable"
                    >
                        <template v-slot:header>
                            <span v-if="f.key == 'situacao'"> </span>

                            <span v-if="f.key == 'descricao'">
                                {{ $t("tabela-precos") }}
                            </span>

                            <span v-else-if="f.key == 'custo'">
                                {{ $t("tabelapreco-custo") }}
                            </span>

                            <span v-else-if="f.key == 'valorunitario'">
                                {{ $t("tabelapreco-valorunitario") }}
                            </span>

                            <span v-else-if="f.key == 'valor1'">
                                {{ $t("valor") }}
                            </span>

                            <span v-else-if="f.key == 'valorminimo'">
                                {{ $t("tabelapreco-valorminimo") }}
                            </span>

                            <span v-else-if="f.key == 'valormaximo'">
                                {{ $t("tabelapreco-valormaximo") }}
                            </span>

                            <span v-else-if="f.key == 'desconto'">
                                {{ $t("tabelapreco-descmaximo") }}
                            </span>

                            <span v-else-if="f.key == 'margemitem'">
                                {{ $t("tabelapreco-margemitem") }}
                            </span>

                            <span v-else-if="f.key == 'datamaxima'">
                                {{ $t("data-validade") }}
                            </span>

                            <span v-else-if="f.key == 'replicapda'">
                                {{ $t("replicapda") }}
                            </span>

                            <span v-else-if="f.key == 'excluir'"> </span>
                        </template>

                        <template v-slot="props">
                            <div v-if="f.key == 'situacao'">
                                <div 
                                    v-if="props.row.situacao != 1"
                                    class="bar a-padrao" 
                                    v-tippy 
                                    :title="$t('msg-tabela-preco-inativa')"
                                />
                            </div>
                            <div v-else-if="f.key == 'descricao'">
                                <a
                                    @click="openModal(props.row)"
                                    v-if="
                                        permissao.update &&
                                        !asstabprecoprodutoIntegracao
                                    "
                                >
                                    <span
                                        class="tag is-info status-tag"
                                        :style="
                                            props.row.cor
                                                ? `background-color: ${props.row.cor}`
                                                : ''
                                        "
                                    >
                                        {{ props.row[f.key] }}
                                    </span>
                                </a>
                                <span
                                    v-else
                                    class="tag is-info status-tag"
                                    :style="
                                        props.row.cor
                                            ? `background-color: ${props.row.cor}`
                                            : ''
                                    "
                                >
                                    {{ props.row[f.key] }}
                                </span>
                            </div>
                            <div 
                            class="nobreak" 
                                v-else-if="f.key == 'custo' 
                                || f.key == 'valorunitario'
                                || f.key == 'valor1'
                                || f.key == 'valorminimo'
                                || f.key == 'valormaximo'"
                            >
                                {{ props.row.moeda }} 
                                {{
                                    getDecimal(props.row[f.key] , null, true)
                                }}
                            </div>
                            <div v-else-if="f.key == 'desconto'
                            || f.key == 'margemitem'">
                                {{ props.row[f.key] }} %
                            </div>
                            <div v-else-if="f.key == 'datamaxima'">
                                {{ props.row[f.key] | moment("L") }}
                            </div>
                            <div v-else-if="f.key == 'replicapda'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    :type="
                                        props.row['replicapda'] == 3
                                            ? 'is-success'
                                            : 'is-danger'
                                    "
                                    size="is-medium"
                                >
                                    {{
                                        $t(
                                            props.row["replicapda"] == 3
                                                ? "ativo"
                                                : "inativo"
                                        )
                                    }}
                                </b-tag>
                            </div>
                            <div v-else-if="f.key == 'excluir'">
                                <b-button
                                    v-if="
                                        permissao.update &&
                                        !asstabprecoprodutoIntegracao
                                    "
                                    class="action-button"
                                    :type="
                                        props.row['replicapda'] == 3
                                            ? 'is-danger'
                                            : 'is-success'
                                    "
                                    :icon-right="
                                        props.row['replicapda'] == 3
                                            ? 'delete'
                                            : 'check'
                                    "
                                    @click="
                                        promptChangeSituacao(props.row)
                                    "
                                    v-tippy 
                                    :title="$t(
                                        props.row['replicapda'] == 3
                                            ? 'desativar'
                                            : 'reativar'
                                    )"
                                />
                            </div>
                        </template>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
            <b-modal
                :active.sync="showModalAssociacao"
                @close="fecharModal"
            >
                <div class="bg">
                    <AssTabprecoProdutoModal
                        :idasstabprecoproduto="idasstabprecoproduto"
                        :idproduto="idproduto"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import VenProdutoService from "@/services/vendas/produto/VenProdutoService";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import Message from "@/models/Message";
import AssTabprecoProdutoModal from "@/components/vendas/produto/modal/AssTabprecoProdutoModal.vue";

export default {
    components: {
        AssTabprecoProdutoModal,
    },
    data() {
        return {
            asstabprecoprodutoIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes(
                    "ASSTABPRECOPRODUTO"
                ),
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            service: new VenProdutoService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            validation: null,
            idpedido: 0,
            idasstabprecoproduto: 0,
            precosFullData: [],
            precosList: [],
            fields: [
                { key: "situacao", width: 5, sortable: false },
                { key: "descricao", width: null, sortable: true },
                { key: "valorunitario", width: 150, sortable: true },
                { key: "valor1", width: 150, sortable: true },
                { key: "valorminimo", width: 150, sortable: true },
                { key: "valormaximo", width: 150, sortable: true },
                { key: "desconto", width: 100, sortable: true },
                { key: "custo", width: 100, sortable: true },
                { key: "margemitem", width: 100, sortable: true },
                { key: "datamaxima", width: 120, sortable: true },
                { key: "replicapda", width: 80, sortable: true },
                { key: "excluir", width: 20, sortable: true },
            ],
            deleteThis: [],
            empresas: [],
            isLoading: false,
            isEmpty: true,
            delete: null,
            permissaoCadastrar: false,
            situacaoSelected: { id: 4, label: "todos" },
            situacaoSelect: [
                { id: 4, label: "todos" },
                { id: 3, label: "ativos" },
                { id: 2, label: "inativos" },
            ],
            debouncedOnSearch: null,
            queryFilter: "",
            column: "DESCRICAO",
            order: "asc",
            showModalAssociacao: false,
            modalManage: false,
        };
    },
    created() {
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            "vendas",
            "produtos",
            "ven-produto-dados-cadastrais-preco"
        );

        this.permissaoCadastrar = this.permissao.create;

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "preco" },
            });
        } else {
            this.idproduto = parseInt(this.$route.params.id);
            this.loadEmpresasId();
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        loadEmpresasId() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: `${e.id}` });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: `${e.id}` });
                });
            }
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }
            this.isLoading = true;
            let empresas = "0, ";
            for (let e of this.empresas) {
                empresas += `${e.id}, `;
            }
            empresas = empresas.slice(0, -2);
            this.service
                .loadPreco(
                    this.idproduto,
                    empresas,
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    this.queryFilter
                )
                .then((r) => {
                    this.pagination.totalRows = r.totalElements;
                    if (r.content) {
                        this.precosList = this.mapItems(r.content);
                        this.precosFullData = r.content;
                    }
                    this.isEmpty = this.precosList ? this.precosList.length == 0 : true
                })
                .catch((e) => {
                    this.isLoading = false;
                    console.error("Erro ao carregar tabela de preço.", e);

                    this.msgs.push(
                        new Message("error", "msg-erro-tab-preco", true)
                    );
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(precos) {
            let mappedPrices = []

            for (let p of precos) {
                let preco = {
                    idtabpreco: p.tabpreco.idtabpreco,
                    descricao: p.tabpreco.descricao,
                    situacao: p.tabpreco.situacao,
                    datamaxima: p.datamaxima,
                    custo: p.custoproduto,
                    valorunitario: p.valorunitario,
                    valor1: p.valor1,
                    valorminimo: p.valorminimo,
                    valormaximo: p.valormaximo,
                    desconto: p.descmaximo1,
                    margemitem: p.margemitem,
                    replicapda: p.replicapda,
                    cor: p.tabpreco.cor ? p.tabpreco.cor : null,
                    moeda: p.tabpreco.moeda.simbolomonetario,
                    idasstabprecoproduto: p.idasstabprecoproduto,
                };
                mappedPrices.push(preco);
            }
            return mappedPrices;
        },
        sortTable(field, order) {
            if (field == "codigo") field = "idprodutoerp";
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? "msg-confirmacao-desativacao-n"
                        : "msg-confirmacao-reativacao-n", 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? "msg-sucesso-ao-reativar-associacao-produto"
                    : "msg-sucesso-ao-desativar-associacao-produto";

            let tempAsstabprecoproduto = {
                idasstabprecoproduto: this.delete.idasstabprecoproduto,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.service
                .updatePrecoSituacao(tempAsstabprecoproduto)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? "msg-sucesso-ao-reativar-associacao-produto"
                                : "msg-sucesso-ao-desativar-associacao-produto";
                        this.$root.showMessage("success", tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage(
                            "error",
                            "Erro ao atualizar status."
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao atualizar status.", e);
                    this.$root.showMessage("error", tempFailure);
                    this.isLoading = false;
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        decimalPlaces(n) {
            let places = typeof n != "number" ? 2 : n > 8 ? 8 : n < 0 ? 0 : n;
            return {
                minimumFractionDigits: places,
                maximumFractionDigits: places,
            };
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        openModal(selected) {
            this.idasstabprecoproduto = selected.idasstabprecoproduto;
            this.showModalAssociacao = true;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.modalManage = false;
            this.carregarDados();
        },
    },
};
</script>
<style>
    .nobreak{
        word-break: initial;
    }
</style>

<style lang="scss" scoped>
.aba-preco {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>